import { css, Theme } from "@emotion/react";

export const pageContainer = (theme: Theme) => css`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  min-height: 112px;

  ${theme.mediaQueries.smallOnly} {
    display: flex;
    flex-direction: column;
    align-content: flex-start;
    justify-content: flex-start;
    align-items: flex-start;
    position: relative;
  }
`;

export const iconStyle = css`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0;
  gap: 10px;

  width: 20px;
  height: 20px;
`;

export const invisibleLink = css`
  text-decoration: none;
  color: black;
`;
